import { Injectable } from '@angular/core';
import { PortalSettingsService } from './portal-settings.service';
import { EmployeeInfoService } from './employee-info.service';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {
  portalSettings: any;
  employeeInfo: any;

  constructor(portalSettingsService: PortalSettingsService, employeeInfoService: EmployeeInfoService) {
    this.portalSettings = portalSettingsService.getPortalSettings();
    this.employeeInfo = employeeInfoService.getEmployeeInfo();
  }

  public getDeviceType() {
    const ua = navigator.userAgent;

    if (/(tablet|ipad|playbook|silk|Macintosh)|(android(?!.*mobi))/i.test(ua)) {
      return "tablet";
    }
    if (/Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
      return "mobile";
    }
    return "desktop";
  };

  public isMobileMode() {
    if (typeof window.orientation !== "undefined")
      return true;
    var check = false;
    ((a) => { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true })(navigator.userAgent || navigator.vendor);
    return check;
  }

  public getDateFormat() {
    if (this.portalSettings.CountryDateCode.ConfigValue == "AU" || this.portalSettings.CountryDateCode.ConfigValue == "CAN") {
      return "dd/MM/yyyy";
    }
    else {
      return "MM/dd/yyyy";
    }
  }

  public getDefaultDatepickerOptions(){
    let format = this.getDateFormat();
    return {
      dateInputFormat: format.toUpperCase(),
      containerClass: "theme-blue",
      showTodayButton: true,
      showClearButton: true,
      clearPosition: "left",
      showWeekNumbers: false
    };
  }

  public getTimeSpanInterval() {
    let intervalConfig = parseInt(this.portalSettings.TimeSpanInterval.ConfigValue);
    if (intervalConfig != 15 && intervalConfig != 30 && intervalConfig != 60) {
      intervalConfig = 0;
    }
    return intervalConfig;
  }

  public fadeLabel(status) {
    var hour = new Date().getHours();
    var APM = " AM";
    var hourStr, minStr;
    hourStr = hour.toString();
    if (hour == 24) { hour = 0; APM = " PM"; }
    if (hour == 12) { APM = " PM"; }
    if (hour > 12) { hour = hour - 12; APM = " PM"; }
    if (hour < 10) { hourStr = "0" + hour.toString(); }
    var min = new Date().getMinutes();
    minStr = min.toString();
    if (min < 10) { minStr = "0" + min.toString() };
    var sec = new Date().getSeconds();
    if (sec < 10) { minStr = "0" + sec.toString() };
    return ({ status: (status ? "success" : "danger"), time: hourStr + ":" + minStr + ":" + sec + APM });
  }

  public formatAttachmentName(fileName) {
    return fileName.substr(0, fileName.lastIndexOf('.')).replace(/[^a-zA-Z0-9]/gi, '') + fileName.substr(fileName.lastIndexOf('.'), fileName.length);
  }

  public openModal() {
    document.getElementById('modal').style.display = 'block';
    document.getElementById('modal').style.left = (window.innerWidth - 200) / 2 + 'px';
    document.getElementById('fade').style.display = 'block';
  }

  public closeModal() {
    document.getElementById('modal').style.display = 'none';
    document.getElementById('fade').style.display = 'none';
  }

  public getCurrencySymbol() {
    var currencyFormatSymbols = this.portalSettings.CurrencyFormatPerPRCo.ConfigValue;

    var currencySymbol = "$";
    if (currencyFormatSymbols && currencyFormatSymbols.trim() !== "") {
      currencyFormatSymbols.split(",").forEach((val: string) => {
        var arrayEntry = val.split(":");
        var currencyObject = { PRCo: parseInt(arrayEntry[0]), Currency: arrayEntry[1] }
        if (this.employeeInfo && currencyObject.PRCo == this.employeeInfo.PRCo) {
          currencySymbol = currencyObject.Currency;
        }
      });
    }

    return currencySymbol;
  }

  public rdlNameList() {
    return {
      "BenefitWindowAuditOverride": "BenefitWindowAuditReport.rdl", "CrewTimecardReportName": "HRIM_CrewTimecard.rdl", "DRTOverrideRDL": "HRIM_DailyTimeReport.rdl",
      "DailyHuddleRDLOverRide": "HRIM_HuddleDHCompliance.rdl", "DailyHuddleTPRDLOverRide": "HRIM_HuddleTPCompliance.rdl", "DailyReportSSRSOverride": "HRIM_DailyReport.rdl",
      "JCDetailRDLOverride": "JCDetail.rdl", "JobApprovalReportOverride": "HRIM_JobApproval.rdl", "POPendingSSRSOverride": "HRIM_PendingPurchaseOrder.rdl", "JCDetailRDLOverrideNexGen": "JobCostDetail.rdl",
      "POSSRSOverride": "HRIM_PurchaseOrder.rdl", "RDLOverride": "HRIM_ExpenseReport.rdl", "ShippingLabelRDLOverride": "HRIM_ShippingLabel.rdl",
      "TimecardRptName": "HRIM_Timecard.rdl", "TotalCompRptName": "HRTotalCompensation.rdl", "TrainingRosterRDLOverride": "HRIM_TrainingRoster.rdl", "TimecardAuditOverride": "HRIM_TimecardAudit.rdl",
      "TrainingTranscriptRDLOverride": "HRIM_TrainingTranscript.rdl", "WorkCompleteRDL": "HRIM_SMWorkCompleted.rdl", "SMForm": "HRIM_SMForm.rdl", "1": "1095CIndividual.rdl", "2": "BenefitExport.rdl", "3": "BenefitsGrid.rdl", "4": "ChecklistExport.rdl",
      "5": "HRIM_ADGetPaperConsent.rdl", "6": "HRIM_ApplicantSummary.rdl", "7": "HRIM_BulletinExport.rdl", "8": "HRIM_Checklist.rdl", "10": "HRIM_DailySchedulePrint.rdl",
      "11": "HRIM_DailyTimecardPrint.rdl", "22": "HRIM_I9.rdl", "12": "HRIM_I9Page2.rdl", "13": "HRIM_JobTemplate.rdl", "14": "HRIM_OnBoarding.rdl", "15": "HRIM_PerformanceGraph.rdl",
      "16": "HRIM_PerformanceReview.rdl", "17": "HRIM_PerformanceTabular.rdl", "18": "HRIM_ReqSummary.rdl", "19": "HRIM_SelfIdentify.rdl", "20": "HRIM_TrainingExport.rdl",
      "21": "HRIM_UnapprovedBenefitRequests.rdl", "23": "HRIM_W4.rdl", "24": "HRIM_W4es.rdl", "25": "HRIM_W4Template.rdl", "26": "RMProjectSchedule.rdl", "27": "RMRoleSchedule.rdl", "28": "HRIM_W4_2020.rdl",
      "30": "HRIM_ApplicantExport.rdl", "31": "HRIM_ApplicantActiveStatusSummary.rdl", "32": "HRIM_ApplicantDemographics.rdl", "33": "HRIM_ApplicantSourcing.rdl",
      "34": "HRIM_ApplicantTimeToHire.rdl", "35": "HRIM_SelfIdentify_2020.rdl", "36": "HRIM_ApplicantOfferToHire.rdl", "37": "1095CIndividual2020.rdl", "38": "HRIM_SelfIdentify_2023.rdl",
      "39": "HRIM_I9Nov2023.rdl", "40": "HRIM_I9SupA.rdl", "41": "HRIM_I9SupB.rdl"
    };
  }

  public checkFileExtension(fileType) {
    if (fileType != null &&
      (fileType.toLowerCase() == "pdf" || fileType.toLowerCase() == ".pdf" ||
        fileType.toLowerCase() == "jpg" || fileType.toLowerCase() == ".jpg" ||
        fileType.toLowerCase() == "jpeg" || fileType.toLowerCase() == ".jpeg" ||
        fileType.toLowerCase() == "png" || fileType.toLowerCase() == ".png" ||
        fileType.toLowerCase() == "gif" || fileType.toLowerCase() == ".gif" ||
        fileType.toLowerCase() == "tiff" || fileType.toLowerCase() == ".tiff" ||
        fileType.toLowerCase() == "tif" || fileType.toLowerCase() == ".tif" ||
        fileType.toLowerCase() == "bmp" || fileType.toLowerCase() == ".bmp"))
        return true;
      else
        return false;
  }

  public base64ArrayBuffer(arrayBuffer: any) {
    var base64 = ''
    var encodings = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'

    var bytes = new Uint8Array(arrayBuffer)
    var byteLength = bytes.byteLength
    var byteRemainder = byteLength % 3
    var mainLength = byteLength - byteRemainder

    var a, b, c, d
    var chunk

    // Main loop deals with bytes in chunks of 3
    for (var i = 0; i < mainLength; i = i + 3) {
      // Combine the three bytes into a single integer
      chunk = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2]

      // Use bitmasks to extract 6-bit segments from the triplet
      a = (chunk & 16515072) >> 18 // 16515072 = (2^6 - 1) << 18
      b = (chunk & 258048) >> 12 // 258048   = (2^6 - 1) << 12
      c = (chunk & 4032) >> 6 // 4032     = (2^6 - 1) << 6
      d = chunk & 63               // 63       = 2^6 - 1

      // Convert the raw binary segments to the appropriate ASCII encoding
      base64 += encodings[a] + encodings[b] + encodings[c] + encodings[d]
    }

    // Deal with the remaining bytes and padding
    if (byteRemainder == 1) {
      chunk = bytes[mainLength]

      a = (chunk & 252) >> 2 // 252 = (2^6 - 1) << 2

      // Set the 4 least significant bits to zero
      b = (chunk & 3) << 4 // 3   = 2^2 - 1

      base64 += encodings[a] + encodings[b] + '=='
    } else if (byteRemainder == 2) {
      chunk = (bytes[mainLength] << 8) | bytes[mainLength + 1]

      a = (chunk & 64512) >> 10 // 64512 = (2^6 - 1) << 10
      b = (chunk & 1008) >> 4 // 1008  = (2^6 - 1) << 4

      // Set the 2 least significant bits to zero
      c = (chunk & 15) << 2 // 15    = 2^4 - 1

      base64 += encodings[a] + encodings[b] + encodings[c] + '='
    }

    return base64
  }
}
